import { render, staticRenderFns } from "./ParecerParametrizado.vue?vue&type=template&id=122cf640&scoped=true"
import script from "./ParecerParametrizado.vue?vue&type=script&lang=js"
export * from "./ParecerParametrizado.vue?vue&type=script&lang=js"
import style0 from "./ParecerParametrizado.vue?vue&type=style&index=0&id=122cf640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122cf640",
  null
  
)

export default component.exports